import * as Page from '@avcan/prismic/clients/page'
import { Page as Layout } from 'layouts/pages'
import { Static } from 'prismic/layouts'

export async function getStaticProps({ locale }) {
    return {
        props: {
            document: await Page.get('privacy-policy', locale),
        },
    }
}

export default function PrivacyPolicy({ document }) {
    return (
        <Layout>
            <Static document={document} />
        </Layout>
    )
}
